<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-alert
        type="info"
        show-icon
        style="margin-bottom: 16px"
        message="序列号规范"
        description="蓝牙MAC格式：AA:BB:CC:DD:EE:FF（大写）。设备序列号 = MP + 去掉冒号后的12位MAC，例如 MAC=98:A3:16:E7:8B:D2 → SN=MP98A316E78BD2。填写MAC并失焦后会自动生成序列号。"
      />
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="蓝牙MAC地址" prop="bluetoothMac" extra="标准格式：AA:BB:CC:DD:EE:FF">
        <a-input v-model="form.bluetoothMac" placeholder="如 98:A3:16:E7:8B:D2" @blur="syncDeviceSnFromMac" />
      </a-form-model-item>
      <a-form-model-item label="设备序列号" prop="deviceSn" extra="标准格式：MP + 12位MAC，如 MP98A316E78BD2">
        <a-input v-model="form.deviceSn" placeholder="如 MP98A316E78BD2" />
      </a-form-model-item>
      <a-form-model-item label="设备名称" prop="deviceName" >
        <a-input v-model="form.deviceName" placeholder="请输入设备名称" />
      </a-form-model-item>
      <a-form-model-item label="绑定时间" prop="bindTime" >
        <a-date-picker style="width: 100%" v-model="form.bindTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDevice, addDevice, updateDevice } from '@/api/mibo/device'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        deviceTypeId: 1,

        deviceSn: null,

        bluetoothMac: null,

        deviceName: null,

        ownerPetId: 0,

        bindStatus: 0,

        onlineStatus: 0,

        bindTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        deviceSn: [
          { required: true, message: '设备序列号不能为空', trigger: 'blur' },
          { validator: this.validateDeviceSn, trigger: 'blur' }
        ],
        bluetoothMac: [
          { required: true, message: '蓝牙MAC地址不能为空', trigger: 'blur' },
          { validator: this.validateBluetoothMac, trigger: 'blur' }
        ],
        deviceName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    isStandardMac (mac) {
      return /^[0-9A-F]{2}(:[0-9A-F]{2}){5}$/.test((mac || '').trim().toUpperCase())
    },
    isStandardSn (sn) {
      return /^MP[0-9A-F]{12}$/.test((sn || '').trim().toUpperCase())
    },
    expectedSnFromMac () {
      const mac = (this.form.bluetoothMac || '').trim().toUpperCase()
      return this.isStandardMac(mac) ? `MP${mac.replace(/:/g, '')}` : ''
    },
    syncDeviceSnFromMac () {
      if (!this.form.bluetoothMac) {
        return
      }
      this.form.bluetoothMac = this.form.bluetoothMac.trim().toUpperCase()
      this.$refs.form && this.$refs.form.validateField('bluetoothMac')
      const expectedSn = this.expectedSnFromMac()
      if (expectedSn) {
        this.form.deviceSn = expectedSn
        this.$nextTick(() => this.$refs.form && this.$refs.form.validateField('deviceSn'))
      }
    },
    validateBluetoothMac (rule, value, callback) {
      const mac = (value || '').trim().toUpperCase()
      if (!mac) {
        callback()
        return
      }
      if (!this.isStandardMac(mac)) {
        callback(new Error('蓝牙MAC格式错误，正确格式如 98:A3:16:E7:8B:D2'))
        return
      }
      callback()
    },
    validateDeviceSn (rule, value, callback) {
      const sn = (value || '').trim().toUpperCase()
      if (!sn) {
        callback()
        return
      }
      if (!this.isStandardSn(sn)) {
        callback(new Error('设备序列号格式错误，正确格式如 MP98A316E78BD2'))
        return
      }
      const expectedSn = this.expectedSnFromMac()
      if (expectedSn && sn !== expectedSn) {
        callback(new Error(`设备序列号与MAC不匹配，应为 ${expectedSn}`))
        return
      }
      callback()
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        deviceTypeId: 1,
        deviceSn: null,
        bluetoothMac: null,
        deviceName: null,
        ownerPetId: 0,
        bindStatus: 0,
        onlineStatus: 0,
        bindTime: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDevice({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.deviceTypeId === null || this.form.deviceTypeId === undefined || this.form.deviceTypeId === '') {
            this.form.deviceTypeId = 1
          }
          if (this.form.ownerPetId === null || this.form.ownerPetId === undefined || this.form.ownerPetId === '') {
            this.form.ownerPetId = 0
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDevice(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDevice(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
